// extracted by mini-css-extract-plugin
export default {"requirementsList":"PasswordRequirements_requirementsList__r3Hrp","requirement":"PasswordRequirements_requirement__3EEAN"};